import React, { Component } from 'react';
import { connect } from '@common/components/base.component';
import autoBind from 'react-autobind';
import navbarSelectors from '@common/store/navbar/navbar.selectors';
import NavbarMenuAction from '@common/components/navbar/menu/navbar.menuAction';

class NavbarSearch extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      showInfo: false,
      filter: '',
      menuSearchFiltered: [],
    };
  }

  UNSAFE_componentWillReceiveProps() {
    const { menuSearch } = this.props.navbarSelectors;
    this.setState({ menuSearchFiltered: menuSearch });
  }

  showInfo() {
    this.setState({ showInfo: true });
  }

  hideInfo() {
    this.clearFilter();
    this.setState({ showInfo: false });
  }

  async handleChange(event) {
    const filter = event.target.value;

    await this.setState({ filter });
    this.applyFilter();
  }

  applyFilter() {
    const { menuSearch } = this.props.navbarSelectors;
    const { filter } = this.state;

    const menuSearchFiltered = menuSearch.filter((item) => item.name.toUpperCase().indexOf(filter.toUpperCase()) >= 0);
    this.setState({ menuSearchFiltered });
  }

  clearFilter() {
    const { menuSearch } = this.props.navbarSelectors;
    this.setState({ filter: '', menuSearchFiltered: menuSearch });
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  render() {
    const { showInfo, menuSearchFiltered } = this.state;

    return (
      <div className="search-container mr-2" onMouseEnter={this.showInfo} onMouseLeave={this.hideInfo}>
        <div className="search-content">
          <i className="fa fa-search" />

          {showInfo && (
            <div className="search-info">
              <input
                type="text"
                placeholder="Pesquisa de menu"
                className="form-control"
                onChange={this.handleChange}
                onClick={this.stopPropagation}
              />

              {menuSearchFiltered.length && (
                <ul>
                  {menuSearchFiltered.map((item, index) => (
                    <li key={index}>
                      <a href={item.link} className="nav-header-submenu-item-link link-menu-search">
                        {item.name}
                      </a>
                      <div className="box-more-actions">
                        {item.list && <NavbarMenuAction type="list" link={item.list} />}
                        {item.add && <NavbarMenuAction type="add" link={item.add} />}
                      </div>
                      <a href={item.link} className="parent-menu-search">
                        {item.parent}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default connect({
  selectors: {
    navbarSelectors,
  },
})(NavbarSearch);
